import React, { useState } from "react";
import { Formik, Form } from "formik";
import {
  LoginInputWrapper,
  RegisterWrapper,
  SubmitBtn
} from "../../../UI/register";
import { createFormInitial, createSendForm } from "../../../../utils/form";
import { signUpSchema } from "../../../../configs/formSchema";
import Input from "./input";
import { withRouter } from "react-router";
import { SignUpValidSchema } from "../../../../configs/validationSchemas";
import ProfilePic from "./choosePic";
import lstool from "../../../../utils/localStorage";
import fetchModule from "../../../../utils/fetchingData";
import API from "./../../../../configs/API";
import { toast } from "react-toastify";
function SignUp(props) {
  let [state, setState] = useState(false);
  const submit = async val => {
    const FormSend = { ...val, reagentid: "" };
    setState(true);
    try {
      const form = {
        ...FormSend,
        mobilenumber: lstool.get("phone"),
        type: API.signup
      };

      let response = await fetchModule.post(
        "",
        createSendForm(
          form,
          [
            ...signUpSchema,
            { name: "mobilenumber" },
            { name: "type" },
            { name: "reagentid" }
          ],
          "multiPart"
        )
      );
      if (response === true) {
        toast.success("ثبت نام با موفقیت انجام شد");
        lstool.remove("phone");
        props.history.push("/login");
      } else {
        toast.error(response);
      }
    } catch (error) {
      toast.error("مشکلی پیش آمده.دوباره تلاش کنید");
    } finally {
      setState(false);
    }
  };
  return (
    <Formik
      validationSchema={SignUpValidSchema}
      initialValues={createFormInitial(signUpSchema)}
      validateOnChange={false}
      validateOnBlur={true}
      onSubmit={submit}
    >
      {props => {
        return (
          <RegisterWrapper as={Form}>
            <ProfilePic set={props.setFieldValue}></ProfilePic>
            <LoginInputWrapper className="sign-in">
              {signUpSchema.map(item => (
                <Input
                  {...item}
                  key={item.name}
                  error={
                    props.errors[item.name] && props.touched[item.name]
                      ? props.errors[item.name]
                      : null
                  }
                ></Input>
              ))}
            </LoginInputWrapper>
            <div>
              <SubmitBtn type="submit" loading={state}>
                تکمیل ثبت نام
              </SubmitBtn>
            </div>
          </RegisterWrapper>
        );
      }}
    </Formik>
  );
}
export default withRouter(SignUp);
